export default __webpack_public_path__ + "static/media/File No. 22.7a90e9b1.pdf";